import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.6537 5.19282C4.64208 3.3546 6.12275 1.85505 7.96096 1.84338C9.7992 1.83171 11.2988 3.31241 11.3104 5.15065L11.3179 6.32914C11.3196 6.60528 11.0972 6.83055 10.8211 6.8323C10.5449 6.83405 10.3197 6.61161 10.3179 6.33548L10.3104 5.15699C10.3023 3.87101 9.25325 2.83519 7.96732 2.84336C6.68136 2.85153 5.64556 3.90054 5.65368 5.18649C5.65368 5.18649 5.65368 5.18649 5.65368 5.18649L5.66115 6.36498C5.6629 6.64112 5.44046 6.86639 5.16432 6.86814C4.88819 6.86989 4.66292 6.64745 4.66117 6.37132L4.6537 5.19282Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.17889 9.16792C5.45503 9.16617 5.6803 9.38861 5.68205 9.66474L5.68952 10.8432C5.68952 10.8432 5.68952 10.8432 5.68952 10.8432C5.69769 12.1292 6.74671 13.165 8.03266 13.1569C9.3186 13.1487 10.3544 12.0997 10.3463 10.8137L10.3388 9.63524C10.3371 9.35911 10.5595 9.13383 10.8356 9.13208C11.1118 9.13034 11.337 9.35277 11.3388 9.62891L11.3463 10.8074C11.3579 12.6456 9.87721 14.1452 8.03898 14.1568C6.20076 14.1685 4.70121 12.6878 4.68954 10.8496L4.68207 9.67108C4.68032 9.39494 4.90276 9.16967 5.17889 9.16792Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.98337 5.37884C8.25951 5.37709 8.48478 5.59953 8.48653 5.87567L8.51341 10.1182C8.51516 10.3944 8.29272 10.6196 8.01659 10.6214C7.74045 10.6231 7.51518 10.4007 7.51343 10.1246L7.48655 5.882C7.4848 5.60586 7.70724 5.38059 7.98337 5.37884Z"
      fill="currentColor"
    />
  </SvgIcon>
));
